<template>
  <div
    class="w-100 d-flex flex-column align-items-center footer-pad"
    :style="{ backgroundColor: theme_option?.sb_theme_info?.footer_background_color || null }"
    :class="[{ 'bgray-1000': !theme_option?.sb_theme_info?.footer_background_color }]"
  >
    <div id="footer-skep" :class="['padded-container', 'w-100']">
      <b-row class="mb-3" no-gutters>
        <b-col cols="6">
          <b-link @click.prevent="go_sb_main">
            <b-img :src="logoUrl" class="footer-sb-logo" />
          </b-link>
        </b-col>
        <b-col cols="6" align-self="center" style="text-align: right !important">
          <b-link
            v-for="link in footerFamilyLinks"
            :key="link.id"
            :href="link.url"
            target="_blank"
            class="mx-2 my-1 text-white fw-600"
            variant="link"
            style="text-decoration: none !important"
          >
            {{ link.url_name }}
          </b-link>
          <b-link
            v-for="link in footerExternalLinks"
            :key="link.id"
            :href="link.url"
            target="_blank"
            class="mx-2 my-1 text-white footer-link fw-600"
            variant="link"
          >
            {{ link.url_name }}
          </b-link>
        </b-col>
      </b-row>

      <b-row no-gutters>
        <b-col cols="12" class="d-none d-xl-flex justify-content-start pb-3 pb-xl-5">
          <footerNav :lang="lang" />
        </b-col>
      </b-row>
    </div>

    <div
      :class="[
        'padded-container',
        'w-100',
        { 'bgray-1000': !theme_option?.sb_theme_info?.footer_background_color }
      ]"
      :style="{ backgroundColor: theme_option?.sb_theme_info?.footer_background_color || null }"
    >
      <b-row no-gutters>
        <b-col cols="6" class="d-flex align-items-center">
          <h6 class="footer-text mb-0 text-white">
            {{
              lang === 'KOR'
                ? selected_report?.organization_name
                : selected_report?.organization_name_e
            }}
            ALL RIGHTS RESERVED.
          </h6>
        </b-col>
        <b-col cols="6" class="d-flex justify-content-end align-items-center">
          <SbFooter />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SbFooter from '../viewer_component/SbFooter.vue';
import { mapGetters, mapState, mapMutations } from 'vuex';
import footerNav from './footer-nav.vue';
import { updateParamsFromQueryString } from '@/components/util';

export default {
  name: 'CommonFooter',
  components: {
    SbFooter,
    footerNav
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_contents', ['theme_option']),
    logoUrl() {
      return this.selected_report.dark_logo_path
        ? `${this.$store.state.static_host}${this.selected_report.dark_logo_path}`
        : `${this.$store.state.static_host}${this.selected_report.logo_path}`;
    },
    footerExternalLinks() {
      return this.theme_option?.sb_theme_info?.footer_external_url || [];
    },
    footerFamilyLinks() {
      return this.theme_option?.sb_theme_info?.footer_family_url || [];
    }
  },
  methods: {
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),

    go_sb_main() {
      // 1. 페이지 최상단으로 스크롤
      window.scrollTo(0, 0);

      // 2. Vuex 상태에서 선택된 목차 초기화
      this.update_selected_lv1({ lv1_info: null, view_mode: this.is_viewer ? 'viewer' : 'editor' });
      this.update_selected_lv2({ lv2_info: null, view_mode: this.is_viewer ? 'viewer' : 'editor' });

      // 3. URL에서 관련 쿼리 파라미터 제거
      updateParamsFromQueryString('lv1', null, true);
      updateParamsFromQueryString('lv2', null, true);
      updateParamsFromQueryString('q_str', null, true);
    }
  }
};
</script>

<style lang="scss">
#footer-skep {
  padding-top: 4rem;

  @media (max-width: 1200px) {
    padding-top: 3.5rem;
  }

  @media (max-width: 992px) {
    padding-top: 3rem;
  }

  @media (max-width: 768px) {
    padding-top: 2.5rem;
  }

  @media (max-width: 576px) {
    padding-top: 2rem;
  }

  &-logo {
    width: 165px;

    max-width: 100%;
    margin-bottom: 2rem;
  }

  p {
    font-weight: 500;
    font-size: 0.9rem;
    color: white;

    @media (max-width: 1200px) {
      font-size: 0.875rem;
    }

    @media (max-width: 992px) {
      font-size: 0.85rem;
    }

    @media (max-width: 768px) {
      font-size: 0.825rem;
    }

    @media (max-width: 576px) {
      font-size: 0.8rem;
    }
  }

  .footer-text {
    opacity: 0.5;
  }

  @media (max-width: 1199px) {
    .footer-submenu {
      display: none !important;
    }
  }

  h3 {
    font-size: 2.5rem;
    color: white;

    @media (max-width: 1200px) {
      font-size: 2.25rem;
    }

    @media (max-width: 992px) {
      font-size: 2rem;
    }

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }

    @media (max-width: 576px) {
      font-size: 1.5rem;
    }
  }

  .footer-sb-logo {
    max-width: 160px;
    max-height: 70px;

    @media (max-width: 576px) {
      max-width: 100px;
      max-height: 45px;
    }
  }

  .footer-link {
    text-decoration: none !important;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
}

.footer-pad {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
